import { render, staticRenderFns } from "./CircleLiveDetail.vue?vue&type=template&id=9bbeb5da&scoped=true"
import script from "./CircleLiveDetail.vue?vue&type=script&lang=js"
export * from "./CircleLiveDetail.vue?vue&type=script&lang=js"
import style0 from "./CircleLiveDetail.vue?vue&type=style&index=0&id=9bbeb5da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbeb5da",
  null
  
)

export default component.exports